export interface CityData {
  name: string
  count: number
  avgPrice: number
  totalValue: number
}

export interface GeographicDistributionData {
  topCities: CityData[]
  totalTransactions: number
}

export interface GeographicDistributionChartLabels {
  activeCities?: string
  totalTransactions?: string
  avgTransactionPrice?: string
  totalMarketVolume?: string
  topCitiesByCount?: string
  topCitiesByVolume?: string
  topCitiesByAvgPrice?: string
  transactions?: string
  avg?: string
  noData?: string
}

export const DEFAULT_GEOGRAPHIC_DISTRIBUTION_CHART_LABELS: GeographicDistributionChartLabels =
  {
    activeCities: 'Active Cities',
    totalTransactions: 'Total Transactions',
    avgTransactionPrice: 'Avg Transaction Price',
    totalMarketVolume: 'Total Market Volume',
    topCitiesByCount: 'Top Cities by Number of Transactions',
    topCitiesByVolume: 'Top Cities by Total Volume',
    topCitiesByAvgPrice: 'Top Cities by Average Price',
    transactions: 'transactions',
    avg: 'Avg',
    noData: 'No data available',
  }

export interface GeographicDistributionChartProps {
  data: GeographicDistributionData | null
  loading?: boolean
  error?: string | null
  labels?: Partial<GeographicDistributionChartLabels>
}
